export default {"src":"/_next/static/media/UPST.425fee42.svg","height":18,"width":18};